import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { ThemeContext, LanguageContext, UserContext, ActionContext } from "../../contexts/Context";
import axios from "axios";
import { IoCloseCircle } from "react-icons/io5";
import promotion from "../customerComponents/Promotion";

const CustomerRedeem = ({ show, setShow, deliveryType }) => {
    const [displayShow, setDisplay] = useState(show ? "grid" : "none");
    const [campaign, setCampaign] = useState([]);
    const [rewardPromo, setRewardPromo] = useState({});
    const [autoItems, setAutoItems] = useState([]);
    const { lanIndex, token, cart, redeem, discount, finalOrder, customer, pm, tax, isTakeAway, paymentData } = React.useContext(UserContext);
    const { addToCart, setRedeem, setDiscount, setFinalOrder, addPromotion } = React.useContext(ActionContext);

    useEffect(() => {
        setDisplay(show ? "flex" : "none");
        if (token) {
            axios.post(`/v2/api/customer/campaign`,
                { customer, redeem, cart, discount },
                {
                    headers: { Authorization: "Bearer " + token },

                })
                .then(function (response) {
                    if (response.status == 200) {
                        setCampaign(response.data.campaign);
                        setAutoItems(response.data.autoItems);
                        setRewardPromo(response.data.rewardPromo);
                    }
                })
                .catch(function (response) {
                    //show warning
                })

        }
    }, []);

    const applyItemDiscount = (item, reward) => {
        item.hasSpecialDiscount = true;
        if (reward.discountType == 2) {
            item.specialDiscount = 1;
        } else if (reward.discountByPercent) {
            item.specialDiscount = reward.discountPercent;
            item.specialDiscountAmount = 0;
        } else {
            item.specialDiscount = 0;
            item.specialDiscountAmount = reward.discountPrice;
        }
        item.specialDiscountRemark = reward.rewardTitle;
        return item;
    }
    const calculateOptionAmt = (i) => {
        let optAmt = 0;
        if (i.optionArray) {
            i.optionArray.forEach((element) => {
                if (element.optionType === 3 || element.optionType === 5) { //set meal
                    if (element.optionActive === true) {
                        element.options.forEach(function (op) {
                            if (!op.active) return;
                            optAmt = optAmt + (op && op.price ? op.price : (op.addPrice ? op.addPrice : 0));
                            op.optionArray.forEach((element) => {
                                element.options.forEach((it) => {
                                    if (it.active) {
                                        if (it.price) {
                                            optAmt += it.price * (it.qty ? it.qty : 1);
                                        } else if (it.addPrice) {
                                            optAmt += it.addPrice * (it.qty ? it.qty : 1);
                                        }
                                    }
                                })
                            });
                        });
                    }
                } else {
                    const filteredArray = element.options.filter(
                        (item) => item.active === true
                    );
                    filteredArray.forEach((item) => {
                        optAmt += item.addPrice * (item.qty ? item.qty : 1);
                    });
                }
            })
        }
        return optAmt;
    }
    const isRedeemLowestReward = (reward) => {
        return reward.redeemLowest === true || reward.redeemLowest === 1 || reward.redeemLowest === "1" || reward.redeemLowest === "true";
    }
    const findRewardItemIndex = (reward, rewardItems) => {
        let selectedIndex = -1;
        for (let i = 0; i < cart.length; i++) {
            let it = cart[i];
            if (it.hasSpecialDiscount) continue;
            if (rewardItems.indexOf(it.codeId) < 0) continue;

            if (selectedIndex < 0) {
                selectedIndex = i;
                continue;
            }

            let selectedAmt = promotion.singleItemDefaultPrice(cart[selectedIndex]);
            let itemAmt = promotion.singleItemDefaultPrice(it);
            if (isRedeemLowestReward(reward) ? selectedAmt > itemAmt : selectedAmt < itemAmt) {
                selectedIndex = i;
            }
        }
        return selectedIndex;
    }
    const redeemReward = (reward) => {
        let rdm = redeem;
        if (!rdm) rdm = [];

        if (reward.notAllowToStack && rdm.some((item) => item.campaignId)) return;

        if (reward.discountType == 4 && rdm.some((item) => item.rewardId == reward._id)) return;

        let rdmObj = {};

        for (let t of rdm) { //redeem item
            if (rdmObj[t.rewardId]) {
                rdmObj[t.rewardId] += t.redeemPts;
            } else {
                rdmObj[t.rewardId] = t.redeemPts;
            }
        }
        let dis = discount;
        let serviceCharge = (!isTakeAway && !paymentData.shouldExcludeDI) ? paymentData.serviceCharge : ((isTakeAway && !paymentData.shouldExclude) ? paymentData.serviceCharge : 0);

        let totalAmt = promotion.subTotalAmount(finalOrder.data, finalOrder.discount);
      
        let pts = customer.rewardPts - customer.redeemPts - (customer.forfeit ? customer.forfeit : 0);

        if (pts < reward.redeemPts) return; //not enough points

        if (!dis) {
            dis = {
                hasFurtherDiscount: false,
                furtherDiscount: 0,
                furtherDiscountAmount: 0,
                furtherDiscountRemark: ""
            }
        }

        if (reward.discountType == 4) {
            if (rewardPromo && rewardPromo[reward._id]) {
                rdm.push({
                    rewardId: reward._id,
                    rewardTitle: reward.rewardTitle,
                    rewardAmt: reward.discountPrice,
                    redeemPts: reward.type == 0 ? reward.redeemPts : 0,
                    discountByPercent: 0,
                    discountPercent: 0,
                    discountPrice: 0,
                    discountType: 4,
                    type: reward.type,
                    qty: 1,
                    index: -1
                });

                let pms;
                if (pm && pm.length > 0) {
                    pms = JSON.parse(JSON.stringify(pm));
                    pms.push(rewardPromo[reward._id]);
                    pms.sort((a, b) => (a.eventPriority < b.eventPriority) ? 1 : -1);
                    // localStorage.setItem("promotion", JSON.stringify(pms));
                    addPromotion(pms);
                } else {
                    pms = [rewardPromo[reward._id]];
                    // localStorage.setItem("promotion", JSON.stringify(pms));
                    addPromotion(pms);
                }
                let newCart = JSON.parse(JSON.stringify(cart));
                newCart = promotion.clearPromotion(newCart);
                newCart = promotion.applyPromotion(pms, newCart);

                finalOrder.redeem = rdm;
                finalOrder.data = newCart;

                setFinalOrder(finalOrder);
                localStorage.setItem("finalOrder", JSON.stringify(finalOrder));
                setDiscount(JSON.parse(JSON.stringify(dis)));
                setRedeem(rdm);
                addToCart(newCart);
                setShow(false);
                setDisplay("none");
            }
        } else if (reward.discountType == 0) {//overall
            if (!reward.discountByPercent) {
                dis.hasFurtherDiscount = true;
                dis.furtherDiscount = 0;
                let discountAmt = 0;
                if (reward.isAfterTax) {
                    discountAmt = reward.discountPrice / (1 + tax.tax);
                    dis.isAfterTax = true;
                } else {
                    discountAmt = reward.discountPrice;
                }

                if (discountAmt > totalAmt) discountAmt = totalAmt;
                dis.furtherDiscountAmount += discountAmt;


                dis.furtherDiscountRemark = reward.rewardTitle;
            } else {
                dis.hasFurtherDiscount = true;
                dis.furtherDiscount = reward.discountPercent;
                dis.furtherDiscountAmount = 0
                dis.furtherDiscountRemark = reward.rewardTitle;
            }

            rdm.push({
                rewardId: reward._id,
                rewardTitle: reward.rewardTitle,
                rewardAmt: reward.discountPrice,
                redeemPts: reward.type == 0 ? reward.redeemPts : 0,
                discountByPercent: reward.discountByPercent,
                discountPercent: reward.discountPercent,
                discountPrice: reward.discountPrice,
                discountType: reward.discountType,
                type: reward.type,
                qty: 1,
                index: -1
            });


            finalOrder.discount = dis;
            finalOrder.redeem = rdm;
            finalOrder.data = cart;
            setFinalOrder(finalOrder);
            localStorage.setItem("finalOrder", JSON.stringify(finalOrder));
            setDiscount(JSON.parse(JSON.stringify(dis)));
            setRedeem(rdm);
            addToCart(cart);
            setShow(false);
            setDisplay("none");
        } else {
            let hasRedeem = false;
            let rewardItems = reward.itemsInclude ? reward.itemsInclude : [];
            let selectedIndex = findRewardItemIndex(reward, rewardItems);
            if (selectedIndex > -1) {
                let it = cart[selectedIndex];
                if (it.qty > 1) {
                    it.qty = it.qty - 1;
                    let newItem = JSON.parse(JSON.stringify(it));
                    newItem.qty = 1;
                    applyItemDiscount(newItem, reward);
               
                    cart.splice(selectedIndex, 0, newItem);
                    rdm.forEach((entry) => {
                        if (entry.index >= selectedIndex) entry.index += 1;
                    });
                } else {
                    applyItemDiscount(it, reward);
                }
                rdm.push({
                    rewardId: reward._id,
                    rewardTitle: reward.rewardTitle,
                    rewardAmt: reward.discountPrice,
                    redeemPts: reward.type == 0 ? reward.redeemPts : 0,
                    discountByPercent: reward.discountByPercent,
                    discountPercent: reward.discountPercent,
                    discountPrice: reward.discountPrice,
                    discountType: reward.discountType,
                    type: reward.type,
                    qty: 1,
                    index: selectedIndex
                });
                finalOrder.redeem = rdm;
                finalOrder.data = cart;
              
                setFinalOrder(finalOrder);
                localStorage.setItem("finalOrder", JSON.stringify(finalOrder));
                setDiscount(JSON.parse(JSON.stringify(dis)));
                setRedeem(rdm);
                addToCart(cart);
                setShow(false);
                setDisplay("none");
                hasRedeem = true;
                return;
            }

            //if can run here, mean the item havent added yet;
            if (!hasRedeem && rewardItems.length > 0) {
                //auto add item tocard
                let codeId = rewardItems[0];
                if (!autoItems || !autoItems[codeId]) return;
                let ct = JSON.parse(JSON.stringify(autoItems[codeId]));
                ct.qty = 1;
                ct.autoAddedReward = true;
                applyItemDiscount(ct, reward);

                cart.push(ct);
                rdm.push({
                    rewardId: reward._id,
                    rewardTitle: reward.rewardTitle,
                    rewardAmt: reward.discountPrice,
                    redeemPts: reward.type == 0 ? reward.redeemPts : 0,
                    discountByPercent: reward.discountByPercent,
                    discountPercent: reward.discountPercent,
                    discountPrice: reward.discountPrice,
                    discountType: reward.discountType,
                    type: reward.type,
                    qty: 1,
                    index: cart.length - 1
                });
                finalOrder.redeem = rdm;
                finalOrder.data = cart;

                setFinalOrder(finalOrder);
                localStorage.setItem("finalOrder", JSON.stringify(finalOrder));
                setDiscount(JSON.parse(JSON.stringify(dis)));
                setRedeem(rdm);
                addToCart(cart);
                setShow(false);
                setDisplay("none");

                return;
            }
        }
    };

    // if (!adCustomer) {
    //     return <></>;
    // }
    return (
        <React.Fragment>
            <ModalContainer display={displayShow}>
                <IconButton onClick={() => {
                    setShow(false);
                    setDisplay(false);
                }}>
                    <IoCloseCircle size={36} />
                </IconButton>
                <ContentWrapper>
                    <Title style={{ marginTop: 16, marginBottom: 4 }}>Available Rewards</Title>
                    <CContainer>
                        {campaign && campaign.map((c, i) =>
                            <CampaignWrapper
                                key={i}
                                onClick={() => { redeemReward(c); }}
                                isValid={true}>
                                <Summary type={c.type}>
                                    {c.discountType == 2 ? "FREE" : c.discountType == 1 ? (c.discountPercent * 100) + "%" : "$" + c.discountPrice}
                                </Summary>
                                <CType type={c.type}>
                                    {c.type == 0 ? "Loyalty Pts" : c.type == 3 ? "Stamp" : c.type == 5 ? "Package" : "Voucher"}
                                </CType>
                                <Description>
                                    {c.rewardTitle}
                                </Description>
                            </CampaignWrapper>
                        )}
                    </CContainer>
                </ContentWrapper>
            </ModalContainer>
        </React.Fragment >
    );
}

export default CustomerRedeem;

const Title = styled.div`
    font-size: 16px;
    font-weight: 400;
`;
const Summary = styled.div`
    font-weight: 700;
    width: 65px;
    padding-left: 8px;
    border-right: 1px solid black;
    display: flex;
    align-items: center;
`;
const CContainer = styled.div`
    flex-grow:1;
    width: 100%;
    display: flex;
    overflow-y: auto;
    flex-direction: column;
`;
const CampaignWrapper = styled.div`
    display: flex;
    position: relative;
    width: 95%;
    border-radius: 8px;
    box-shadow: 0px 1px 3px rgba(0,0,0,0.4);
    margin: 0px 4px;
    margin-top: 16px;
    opacity:${(props) => props.isValid ? 1 : 0.4};
`;
const CType = styled.div`
    position: absolute;
    top: -8px;
    left: -4px;
    color: white;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 12px;
    box-shadow: 0px 1px 3px rgba(0,0,0,0.4);
    background: ${(props) => {
        switch (props.type) {
            case 0:
                return "#4caf50";
            case 3:
            case 4:
            case 6:
                return "#f44336";
            case 5:
                return "#2986cc";
        }
    }};
`;
const Description = styled.div`
    flex-grow:1;
    padding: 16px 4px;
    padding-left: 8px;
    width: 100%;
`;

const IconButton = styled.div`
  position: absolute;
  right: 16px;
  top: 16px;
  background: white;
  z-index: 99;
`;
const ContentWrapper = styled.div`
    display: flex;
    padding: 16px;
    flex-direction: column;
    align-items: center;
    flex-grow:1;
    overflow-y: auto;
    margin-top: 0px;
`;
const ModalContainer = styled.div`
    display: ${(props) => props.display};
    position: fixed;
    flex-direction: column;
    background: #fff;
    top: 0;

    width: 100vw;
    max-width: 550px;
    height: 100dvh;
    z-index: 10;

    animation: modalOrder .1s;
    animation-timing-function: ease-out;
    @keyframes modalOrder {
        0%  {
        transform: translateY(350px);
        opacity: 0;
        }
        
        100%  {
        transform: translateY(0px);
        opacity: 1;
        }
        
    }
  `;

